var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,512 256,256 0,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "0,512 512,512 512,256 256,256 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,0 512,0 512,256 256,256 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 91.62,
    cy: 256,
    r: 28.69
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "91.621,256 80.862,212.966 91.621,198.621 102.379,212.966  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "91.621,256 102.379,299.034 91.621,313.379 80.862,299.034  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "91.621,256 48.586,266.759 34.241,256 48.586,245.241  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "91.621,256 134.655,245.241 149,256 134.655,266.759  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "91.621,256 114.443,217.963 132.194,215.427 129.658,233.178  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "91.621,256 68.798,294.037 51.047,296.573 53.583,278.822  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "91.621,256 53.583,233.178 51.047,215.427 68.798,217.963  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "91.621,256 129.658,278.822 132.194,296.573 114.443,294.037  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M28.365,74.724l1.496,11.16l-10.075,5.028c-1.304,0.651-1.03,2.588,0.405,2.85l11.076,2.026   l1.669,11.136c0.216,1.442,2.143,1.779,2.836,0.496l5.35-9.908l11.106,1.854c1.438,0.24,2.354-1.488,1.348-2.543l-7.77-8.15   l5.195-9.99c0.673-1.293-0.688-2.699-2.002-2.068l-10.152,4.871l-7.896-8.028C29.929,72.419,28.172,73.279,28.365,74.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M32.12,407.143l-1.89,11.1l-11.114,1.806c-1.439,0.234-1.752,2.165-0.461,2.841l9.973,5.227   l-1.717,11.128c-0.222,1.441,1.517,2.335,2.56,1.317l8.053-7.87l10.053,5.072c1.302,0.657,2.69-0.721,2.043-2.028l-4.996-10.091   l7.931-7.994c1.027-1.035,0.145-2.781-1.297-2.57l-11.141,1.633l-5.152-10.013C34.298,405.407,32.365,405.706,32.12,407.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M202.735,239.555l-6.48,9.209l-10.81-3.15c-1.4-0.408-2.513,1.201-1.638,2.367l6.755,9.009   l-6.337,9.308c-0.82,1.205,0.365,2.761,1.745,2.29l10.655-3.641l6.894,8.903c0.893,1.153,2.739,0.506,2.717-0.952l-0.17-11.259   l10.598-3.806c1.372-0.493,1.327-2.448-0.066-2.878l-10.76-3.318l-0.344-11.255C205.447,238.925,203.574,238.363,202.735,239.555z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/ph.87f39bc286bc6b6928b0dd641fd6cab0.svg";
export { ForwardRef as ReactComponent };